import React from "react";
import { connect } from "react-redux";
import { Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import HeadingModule from '../components/Layout/HeadingComponent/Heading';

const AccountSupportModule = () => {
    return (
        <>
            <section className="zl_account_support_page">
                <HeadingModule name={'Soporte de cuenta'} />
                <div className="zl_SecureBackup_heading">
                    <h3>¿Cómo podemos ayudarte?</h3>
                </div>
                <Form className="zl_account_support_input_list">
                    <Form.Group className="zl_account_support_input_items">
                        <Form.Label>Dirección de email</Form.Label>
                        <Form.Control type="email" placeholder="Escribe aquí tu correo" />
                    </Form.Group>
                    <Form.Group className="zl_account_support_input_items">
                        <Form.Label>Mensaje</Form.Label>
                        <Form.Control type="text" placeholder="Escribe aquí tu mensaje" />
                    </Form.Group>
                </Form>
                <div className="zl_securebackup_btn">
                    <Link to={'#'} className="mx-auto">Enviar</Link>
                </div>
            </section>
        </>
    );
}

export default connect(null, null)(AccountSupportModule);
